import React from 'react'
import WalletCarousal from './carousal copy'
import WalletList from './products copy 2'
import { useEffect } from 'react'
import { useContext } from 'react'
import { useLoaderData, useParams } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import NoteContext from '../context/notes/noteContext'
import MetaDecorator from './metaDecorator'
import SubCategoriesPreview from './subcategoriesPreview'
export default function Categories() {
    
    const location = useLocation()
  
    const {id} = useParams()
    const context = useContext(NoteContext)
    const {setCategoryData,deleteCategory,mainLoader,getCategoryData,categoryData,setCatyEditor,setCategorial,editComponent,setComponent,setText,adminView} = context
    const {mainHeading,firstHeading,firstSmallPara,firstSmallParaTwo,firstSmallParaThree,secondHeading,secondSmallPara,secondSmallParaTwo,secondSmallParaThree,mainCarousalImgDesktop} = categoryData
    
    useEffect(() => {
        // window.scroll(0,0)
        getCategoryData(id)

        return ()=>{
            setCategoryData({})
        }
    }, [location.pathname])


  
    
    // console.log(categoryStuff.categoryStuff)

    const catyEditDeclare = (e,compy)=>{
        if(adminView){
            setCatyEditor(true)
            setCategorial(id)
            setText(e.target.innerText);
            editComponent();
            setComponent(compy)
        
        }
        
        }
    
    
    const color = "#212427"
    const removeSpace = mainHeading&& mainHeading.replace(" ","")
    const slug = mainHeading && removeSpace.toLowerCase()



    var excludeString = mainHeading&&mainHeading.substring(mainHeading.indexOf("*") + 1, mainHeading.lastIndexOf("*") );
    const filteredFirstHeading = excludeString?firstHeading.replace(`*${excludeString}*`,""):firstHeading
    console.log(excludeString)
    
    
    // console.log(slug)
    return (
        <>
        <MetaDecorator title={filteredFirstHeading} description={secondHeading} imageUrl={mainCarousalImgDesktop} imageAlt={firstHeading}/>
    {   <div >
            <WalletCarousal />
            <SubCategoriesPreview mainHeading={mainHeading}/>
            <div id='top'>
            <div className="mt-3">
                <WalletList slug={slug} />
            </div>
            </div>
            <div className="pb-5">
                <div className="container ">
                    <div className="pb-5">
                        <p  data-aos="fade-up"  data-aos-duration="1000" onClick={(e)=>{catyEditDeclare(e,'firstHeading')}} style={{ fontFamily: "Sagrantino", fontSize: "38.5px", color: color, fontWeight: "bolder" }} className='text-center mb-4 py-2'>{excludeString?firstHeading.replace(`*${excludeString}*`,""):firstHeading}</p>
                        <p  data-aos="fade-right"  data-aos-duration="1000" onClick={(e)=>{catyEditDeclare(e,'firstSmallPara')}} style={{ fontSize: "16.5px", color: color }}>{firstSmallPara}</p>
                        <p  data-aos="fade-left"  data-aos-duration="1000" onClick={(e)=>{catyEditDeclare(e,'firstSmallParaTwo')}} style={{ fontSize: "16.5px", color: color }}>{firstSmallParaTwo}</p>
                        <p  data-aos="fade-right"  data-aos-duration="1000" onClick={(e)=>{catyEditDeclare(e,'firstSmallParaThree')}} style={{ fontSize: "16.5px", color: color }}>{firstSmallParaThree}</p>

                        <p  data-aos="fade-up"  data-aos-duration="1000" onClick={(e)=>{catyEditDeclare(e,'secondHeading')}} style={{ fontFamily: "Sagrantino", fontSize: "38.5px", color: color }} className='text-center my-2 py-2'>{secondHeading}</p>
                        <p  data-aos="fade-right"  data-aos-duration="1000" onClick={(e)=>{catyEditDeclare(e,'secondSmallPara')}} style={{ fontSize: "16.5px", color: color }}>{secondSmallPara}</p>
                        <p  data-aos="fade-left"  data-aos-duration="1000" onClick={(e)=>{catyEditDeclare(e,'secondSmallParaTwo')}} style={{ fontSize: "16.5px", color: color }}>{secondSmallParaTwo}</p>
                        <p  data-aos="fade-right"  data-aos-duration="1000" onClick={(e)=>{catyEditDeclare(e,'secondSmallParaThree')}} style={{ fontSize: "16.5px", color: color }}>{secondSmallParaThree}</p>
                    </div>
                </div>
            </div>
           {adminView&& <div className="d-flex justify-content-center my-2">
                <button onClick={()=>deleteCategory(id)} className='btn' style={{color:color,borderColor:color,backgroundColor:"#000000"}}>Delete Category</button>
            </div>}
        </div>}
        </>
    )
}

